// extracted by mini-css-extract-plugin
export var createdDate = "_k3-1";
export var divider = "_k3-2";
export var headerDivider = "_k3-3";
export var messagesCard = "_k3-0";
export var messagesContainer = "_k3-6";
export var messagesContainerWrapper = "_k3-4";
export var showLeftPanelButton = "_k3-8";
export var topButtons = "_k3-7";
export var withPadding = "_k3-5";